
<p-toast></p-toast>
<!-- <app-topbar></app-topbar> -->
<div class="sticky-toolbar mb-8 text-[14px]">
    <p-toolbar class="text-[14px] p-0 mb-3">
        <ng-template #start>
            <!-- <div class="p-toolbar-title"><h3>Customize Picking List</h3></div> -->
            <!-- <button pButton label="Refresh Picking List" icon="pi pi-refresh" class="mr-2" severity="secondary" (click)="refreshPickingLists()"></button> -->
            <button pButton label="Add Driver" icon="pi pi-user-plus" class="mr-2" severity="secondary" (click)="showAddDriverDialog = true" *ngIf="!isReadOnly"></button>
            <button pButton label="Add Vehicle" icon="pi pi-truck" class="mr-2" severity="secondary" (click)="showAddVehicleDialog = true"  *ngIf="!isReadOnly"></button>
            <button pButton label="Go to Recent Picklist" icon="pi pi-clock" class="mr-2" severity="secondary" (click)="scrollToRecentPicklists()"></button>
        </ng-template>
        <ng-template #end>
            <button pButton type="button" label="Create Picking List" icon="pi pi-plus" [severity]="'primary'" [disabled]="!selectedOrders?.length" class="mr-3" (click)="openDialog()" *ngIf="!isReadOnly"></button>
            <button pButton type="button" label="Add in Existing Picklist" icon="pi pi-folder" [severity]="'primary'" [disabled]="!selectedOrders?.length" class="mr-3" (click)="fetchPickingListsByDate()" *ngIf="!isReadOnly"></button>
            <button pButton label="Back" icon="pi pi-arrow-left" severity="secondary" class="ml-2" (click)="goBack()"></button>
            <!-- <div>Dialog Visible: {{ addToExistingDialogVisible }}</div>
            <button (click)="addToExistingDialogVisible = true">Open Dialog</button> -->


        </ng-template>
    </p-toolbar>
    <!-- Add Driver Dialog -->
    <p-dialog header="Add Driver" 
    [(visible)]="showAddDriverDialog" 
    [modal]="true"
     [closable]="true"
     [appendTo]="'body'"
    >
        <div class="p-fluid">
            <div class="p-field mb-3">
                <label for="driverName">Driver Name</label>
                <input id="driverName" pInputText [(ngModel)]="newDriver.driverName" required />
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton label="Cancel" icon="pi pi-times" (click)="showAddDriverDialog = false"></button>
            <button pButton label="Add" icon="pi pi-check" (click)="createDriver()" [disabled]="!newDriver.driverName"></button>
        </ng-template>
    </p-dialog>

    <!-- Add Vehicle Dialog -->
    <p-dialog header="Add Vehicle"      [appendTo]="'body'" [(visible)]="showAddVehicleDialog" [modal]="true" [closable]="true">
        <div class="p-fluid">
            <div class="p-field mb-3">
                <label for="vehicleNumber">Vehicle Number</label>
                <input id="vehicleNumber" pInputText [(ngModel)]="newVehicle.vehicleNumber" required />
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton label="Cancel" icon="pi pi-times" (click)="showAddVehicleDialog = false"></button>
            <button pButton label="Add" icon="pi pi-check" (click)="createVehicle()" [disabled]="!newVehicle.vehicleNumber"></button>
        </ng-template>
    </p-dialog>
</div>
<!-- <p-toolbar>
    <div class="p-toolbar-group-left">

        <span class="p-toolbar-title p-ml-4 mr-4">
            <i class="pi pi-list mr-2"></i>
            Date Wise Orders
        </span>



        <span class="p-ml-4">
            <input id="fromDate" pInputText [(ngModel)]="fromDate" name="fromDate" type="date" class="p-inputtext p-component mr-2" style="width: 160px" dateFormat="yy-mm-dd" (change)="onDateChange()" [max]="toDate" required />
            <span class="mr-2">to</span>
            <input id="toDate" pInputText [(ngModel)]="toDate" name="toDate" type="date" class="p-inputtext p-component mr-2" style="width: 160px" dateFormat="yy-mm-dd" (change)="onDateChange()" [min]="fromDate" required />
        
            <span class="ml-4 p-mr-4 mr-4"><b>Total Remaining:</b> {{ totalRemaining }}</span>
        </span>
    </div>
    <div class="p-toolbar-group-right p-ml-4">
        <button pButton type="button" label="Create Picking List" icon="pi pi-plus" [severity]="selectedOrders.length ? 'primary' : 'secondary'" [disabled]="!selectedOrders.length" class="mr-4" (click)="openDialog()"></button>
        <button pButton type="button" label="Add in Existing Picklist" icon="pi pi-folder" [severity]="selectedOrders.length ? 'primary' : 'secondary'" [disabled]="!selectedOrders.length" class="p-ml-2" (click)="openAddToExistingDialog()"></button>
    </div>

</p-toolbar> -->
<p-confirmDialog></p-confirmDialog>
<p-table
    #dtOrders
    class="p-mt-3 p-mb-4"
    [value]="orders"
    [globalFilterFields]="['orderNumber', 'customerName', 'customerAddress', 'phoneNumber', 'orderValue', 'grossValue', 'netAmount', 'vatAmount', 'requestedDate', 'status']"
    [(selection)]="selectedOrders"
    dataKey="orderId"
    [paginator]="true"
    [rows]="20"
    [rowsPerPageOptions]="[20, 40, 60, 100, 200, 500, 1000]"
    selectionMode="multiple"
    [rowSelectable]="isOrderSelectable"
    filterDisplay="menu"
    [scrollable]="true"
    [scrollHeight]="'60vh'"
>
    <ng-template #caption>
        <div class="flex justify-between items-center flex-wrap gap-4 w-full">
            <!-- Left Controls: Date Range, Total Remaining -->
            <div class="flex items-center gap-2 flex-wrap">
                <span class="text-lg font-semibold flex items-center gap-2">
                    <i class="pi pi-list mr-2"></i>
                    Date Wise Orders
                </span>
                <input id="fromDate" pInputText [(ngModel)]="fromDate" name="fromDate" type="date" class="p-inputtext p-component" style="width: 160px" dateFormat="yy-mm-dd" (change)="onDateChange()" [max]="toDate" required />
                <span class="mx-1">to</span>
                <input id="toDate" pInputText [(ngModel)]="toDate" name="toDate" type="date" class="p-inputtext p-component" style="width: 160px" dateFormat="yy-mm-dd" (change)="onDateChange()" [min]="fromDate" required />
                <span class="ml-4 font-semibold text-sm">
                    <!-- <b>Total Remaining:</b> <span class="text-primary">{{ totalRemaining }}</span> -->
                </span>
            </div>
            <!-- Center: Global Filter -->
            <div class="flex items-center gap-2"></div>
            <!-- Right Controls: Action Buttons -->
            <div class="flex items-center gap-2">
                <!-- <button pButton type="button" label="Create Picking List" icon="pi pi-plus" [severity]="'primary'" [disabled]="!selectedOrders.length" class="mr-2" (click)="openDialog()"></button>
                <button pButton type="button" label="Add in Existing Picklist" icon="pi pi-folder" [severity]="'primary'" [disabled]="!selectedOrders.length" (click)="fetchPickingListsByDate()"></button> -->
             
                         <button pButton label="Refresh Orders" icon="pi pi-refresh" class="mr-2 ml-2" severity="secondary" (click)="refreshOrders()"></button>

                <span class="p-input-icon-left">

                    <p-iconfield>
                        <p-inputicon styleClass="pi pi-search" />
                        <input pInputText type="text" (input)="onGlobalFilter(dtOrders, $event)" placeholder="Global Search..." />
                    </p-iconfield>
                </span>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr class="sticky top-0 z-10">
            <th style="width: 3em; white-space: nowrap"></th>
            <th style="width: 160px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Order No
                    <p-columnFilter type="text" field="orderNumber" display="menu" placeholder="Filter" />
                </span>
            </th>
            <th style="width: 200px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Customer Name
                    <p-columnFilter type="text" field="customerName" display="menu" placeholder="Filter" />
                </span>
            </th>
            <th style="width: 220px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Customer Address
                    <p-columnFilter type="text" field="customerAddress" display="menu" placeholder="Filter" />
                </span>
            </th>
            <th style="width: 120px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Phone
                    <p-columnFilter type="text" field="phoneNumber" display="menu" placeholder="Filter" />
                </span>
            </th>
            <th style="width: 120px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Order Value
                    <p-columnFilter type="numeric" field="orderValue" display="menu" placeholder="Filter" />
                </span>
            </th>
            <!-- <th style="width: 120px; white-space: nowrap">
            <span class="flex items-center gap-2">
                Gross Value
                <p-columnFilter type="numeric" field="grossValue" display="menu" placeholder="Filter" />
            </span>
        </th>
        <th style="width: 120px; white-space: nowrap">
            <span class="flex items-center gap-2">
                Net Amount
                <p-columnFilter type="numeric" field="netAmount" display="menu" placeholder="Filter" />
            </span>
        </th>
        <th style="width: 120px; white-space: nowrap">
            <span class="flex items-center gap-2">
                VAT Amount
                <p-columnFilter type="numeric" field="vatAmount" display="menu" placeholder="Filter" />
            </span>
        </th> -->
            <th style="width: 140px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Requested Date
                    <p-columnFilter type="text" field="requestedDate" display="menu" placeholder="Filter" />
                </span>
            </th>
            <th style="width: 140px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    UserIdResponsible
                    <p-columnFilter type="text" field="userIdResponsible" display="menu" placeholder="Filter" />
                </span>
            </th>
            <th style="width: 120px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Sync Status
                    <p-columnFilter type="text" field="status" display="menu" placeholder="Filter" />
                </span>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-order>
        <tr [pSelectableRow]="order">
            <td>
                <p-tableCheckbox [value]="order"></p-tableCheckbox>
            </td>
            <td>{{ order.orderNumber }}</td>
            <td>{{ order.customerName }}</td>
            <td>{{ order.customerAddress }}</td>
            <td>{{ order.phoneNumber }}</td>
            <td>{{ order.orderValue }}</td>
            <!-- <td>{{ order.grossValue }}</td>
            <td>{{ order.netAmount }}</td>
            <td>{{ order.vatAmount }}</td> -->
            <td>{{ order.requestedDate }}</td>
            <td>{{ order.userIdResponsible }}</td>
            <td>{{ order.status }}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="11" class="text-center py-4 text-gray-500">No data found for selected date range.</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Create Picking List" [(visible)]="showDialog" [modal]="true" [closable]="false">
    <div class="p-fluid">
        <div class="p-field mb-4">
            <label class="block mb-2 font-semibold">Vehicle Number</label>
            <p-autoComplete
                [(ngModel)]="selectedVehicle"
                [suggestions]="filteredVehicleNumbers"
                (completeMethod)="filterVehicleNumbers($event)"
                [dropdown]="true"
                [field]="'label'"
                [optionLabel]="'label'"
                [optionValue]="'label'"
                placeholder="Select Vehicle"
                [style]="{ width: '200px' }"
                [forceSelection]="true"
                [appendTo]="'body'"
                required
            ></p-autoComplete>
        </div>
        <div class="p-field mb-2 mt-4">
            <label class="block mb-2 font-semibold">Driver Name</label>
            <p-autoComplete
                [(ngModel)]="selectedDriver"
                [suggestions]="filteredDriverNumbers"
                (completeMethod)="filterDriverNumbers($event)"
                [dropdown]="true"
                [field]="'label'"
                [optionLabel]="'label'"
                [optionValue]="'label'"
                placeholder="Select Driver"
                [style]="{ width: '200px' }"
                [forceSelection]="true"
                [appendTo]="'body'"
                required
            ></p-autoComplete>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" icon="pi pi-times" (click)="showDialog = false"></button>
        <button pButton label="OK" icon="pi pi-check" (click)="createPickingList()" [disabled]="!selectedVehicle || !selectedDriver || !selectedOrders?.length"></button>
    </ng-template>
</p-dialog>
<!-- <h3>Recent Picking Lists</h3> -->
<h3 #recentPicklistsSection>Recent Picking Lists</h3>

<!-- Recent Picking Lists Table with Filters and Caption -->
<p-table
    #dtPickingLists
    class="p-mt-3 p-mb-4"
    [value]="recentPickingLists"
    [globalFilterFields]="['code', 'vehicleNo', 'driverNo', 'fromDate', 'toDate']"
    selectionMode="single"
    (onRowSelect)="onPickingListClick($event.data)"
    filterDisplay="menu"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 40, 60, 100]"
    [scrollable]="true"
    [scrollHeight]="'60vh'"
>
    <ng-template #caption>
        <div class="flex justify-between items-center flex-wrap gap-4 w-full">
            <!-- Left: Date Range and Total -->
            <div class="flex items-center gap-2 flex-wrap">
                <span class="text-lg font-semibold flex items-center gap-2">
                    <i class="pi pi-list mr-2"></i>
                    Recent Picking Lists
                </span>
                <input id="fromDatePKL" pInputText [(ngModel)]="fromDatePKL" name="fromDatePKL" type="date" class="p-inputtext p-component" style="width: 160px" dateFormat="yy-mm-dd" (change)="onDateChangePKL()" [max]="toDatePKL" required />
                <span class="mx-1">to</span>
                <input id="toDatePKL" pInputText [(ngModel)]="toDatePKL" name="toDatePKL" type="date" class="p-inputtext p-component" style="width: 160px" dateFormat="yy-mm-dd" (change)="onDateChangePKL()" [min]="fromDatePKL" required />
                <span class="ml-4 font-semibold text-sm">
                    <!-- <b>Total Lists:</b> <span class="text-primary">{{ recentPickingLists.length }}</span> -->
                </span>
            </div>
            <!-- Center: Global Filter -->
            <div class="flex items-center gap-2"></div>
            <!-- Right: Refresh Button -->
            <div class="flex items-center gap-2">
                <button pButton type="button" label="Refresh" icon="pi pi-refresh" severity="secondary" class="mr-2" (click)="fetchRecentPickingLists()"></button>
                <span class="p-input-icon-left">
                    <p-iconfield>
                        <p-inputicon styleClass="pi pi-search" />
                        <input pInputText type="text" (input)="onGlobalFilter(dtPickingLists, $event)" placeholder="Global Search..." />
                    </p-iconfield>
                </span>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr class="sticky top-0 z-10">
            <th style="width: 120px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Code
                    <p-columnFilter type="text" field="code" display="menu" placeholder="Filter" />
                </span>
            </th>
            <th style="width: 160px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Vehicle No
                    <p-columnFilter type="text" field="vehicleNo" display="menu" placeholder="Filter" />
                </span>
            </th>
            <th style="width: 160px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Driver Name
                    <p-columnFilter type="text" field="driverNo" display="menu" placeholder="Filter" />
                </span>
            </th>
            <!-- <th style="width: 140px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    From Date
                    <p-columnFilter type="text" field="fromDate" display="menu" placeholder="Filter" />
                </span>
            </th> -->
            <th style="width: 140px; white-space: nowrap">
                <span class="flex items-center gap-2">
                    Creation Date
                    <p-columnFilter type="text" field="creationDate" display="menu" placeholder="Filter" />
                </span>
            </th>
            <th style="width: 120px; white-space: nowrap">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-list let-rowIndex="rowIndex">
        <tr [pSelectableRow]="list">
            <td>{{ list.code }}</td>
            <td>{{ list.vehicleNo }}</td>
            <td>{{ list.driverNo }}</td>
            <!-- <td>{{ list.fromDate }}</td>
            <td>{{ list.toDate }}</td> -->
            <td>{{ list.creationDate }}</td>
            <td>
                <button pButton icon="pi pi-print" class="p-button-text p-mr-2" (click)="openCustomizeRouteWisePickingList(list)"></button>
                <button pButton icon="pi pi-trash" class="p-button-text p-button-danger" (click)="confirmDeletePickingList(rowIndex)" *ngIf="!isReadOnly"></button>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="11" class="text-center py-4 text-gray-500">No data found for selected date range.</td>
        </tr>
    </ng-template>
</p-table>

<!-- <p-sidebar
  [(visible)]="showPickingListPanel"
  position="right"
  [style]="{ width: '600px' }"
  [baseZIndex]="10000"
  [modal]="true"
  [dismissible]="!isSidebarPinned"
  *ngIf="selectedPickingList"
>
 Top right actions: Pin 
  <div class="p-d-flex p-jc-end p-ai-center" style="gap: 0.5rem; margin-bottom: 1rem;">

    <span
      class="pi"
      [ngClass]="isSidebarPinned ? 'pi-thumbtack-fill' : 'pi-thumbtack'"
      style="font-size: 1.5rem; cursor: pointer; color: #2196f3;"
      (click)="isSidebarPinned = !isSidebarPinned"
      title="Pin/Unpin Sidebar"
    ></span>



  </div>


  <h3>Picking List Details</h3>

 
  <div *ngFor="let order of selectedPickingList.orders; let i = index">
    <div class="p-mb-2">
      <button
        pButton
        type="button"
        label="{{ order.orderNumber }} - {{ order.customerName }}"
        class="p-button-text p-mr-2"
        (click)="selectedOrderIndex = selectedOrderIndex === i ? null : i"
      ></button>

      <div *ngIf="selectedOrderIndex === i" class="p-ml-3 p-mt-2">
        <b>Order Lines:</b>
        <table class="p-datatable p-datatable-sm p-mb-2" style="width: 100%; border-collapse: collapse">
          <thead>
            <tr>
              <th style="border-bottom: 1px solid #ccc">Item Name</th>
              <th style="border-bottom: 1px solid #ccc">Quantity</th>
              <th style="border-bottom: 1px solid #ccc">Pcs</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let line of order.orderLines">
              <td style="padding: 4px 8px">{{ line.itemName }}</td>
              <td style="padding: 4px 8px; text-align: right">{{ line.quantity }}</td>
              <td style="padding: 4px 8px; text-align: right">{{ line.pcs }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr />
  </div>
</p-sidebar> -->

<!-- <p-sidebar [(visible)]="showPickingListPanel" position="right" [style]="{ width: '600px' }" [baseZIndex]="10000" [modal]="true" [dismissible]="!isSidebarPinned" *ngIf="selectedPickingList" (onHide)="onSidebarCancel()">
   
    <ng-template pTemplate="header">
        <div class="sidebar-header-container">
      
            <button class="pin-button" [ngClass]="{ pinned: isSidebarPinned }" (click)="toggleSidebarPin()" title="Pin/Unpin Sidebar" style="margin-right: 8px">
                <i class="pi" [ngClass]="isSidebarPinned ? 'pi-thumbtack-fill' : 'pi-thumbtack'"></i>
            </button>
        </div>
    </ng-template>

   
    <h3>Picking List Details</h3>


    <div *ngFor="let order of selectedPickingList.orders; let i = index">
        <div class="p-mb-2">
            <div class="p-mb-2 d-flex align-items-center">
                <button pButton type="button" class="p-button-text p-mr-2" (click)="selectOrderLine(i)">
                    <span> <b>Order No: </b> {{ order.orderNumber }} - <b>Customer: </b> {{ order.customerName }} - <b>Created: </b> {{ order.creationDate }} </span>
                </button>

                <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" style="margin-left: 8px" (click)="confirmDeletePickingListLine(order)" title="Delete Order from Picking List"></button>
            </div>

            <div *ngIf="selectedOrderIndex === i" class="p-ml-3 p-mt-2">
                <b>Order Lines:</b>
                <table class="p-datatable p-datatable-sm p-mb-2" style="width: 100%; border-collapse: collapse">
                    <thead>
                        <tr>
                            <th style="border-bottom: 1px solid #ccc">Item Name</th>
                            <th style="border-bottom: 1px solid #ccc">Quantity</th>
                            <th style="border-bottom: 1px solid #ccc">Pcs</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let line of order.orderLines">
                            <td style="padding: 4px 8px">{{ line.itemName }}</td>
                            <td style="padding: 4px 8px; text-align: right">{{ line.quantity }}</td>
                            <td style="padding: 4px 8px; text-align: right">{{ line.pcs }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <hr />
    </div>
</p-sidebar>
 -->

<p-dialog header="Picking List Details" [(visible)]="pickingListDialogVisible" [modal]="true" [resizable]="true" appendTo="body" [style]="{ width: '65vw' }" [contentStyle]="{ minHeight: '250px' }">
    <p-table [value]="selectedPickingList?.orders" [tableStyle]="{ 'min-width': '55rem' }" 
    [scrollable]="true" scrollHeight="flex" dataKey="orderNumber" [rowExpandMode]="'multiple'" 
    [scrollable]="true"
     dataKey="orderNumber"
         [rowExpandMode]="'multiple'"
        [scrollHeight]="'50vh'">
  <ng-template #caption>
    <div class="flex justify-between items-center flex-wrap w-full">
        <!-- Left side: Driver Name and Vehicle Number -->
        <div class="flex items-center gap-4">
                <span class="font-semibold text-base">
                Total Orders: <span class="text-primary">{{ selectedPickingList?.orders?.length || '-' }}</span>
            </span>
            <span class="font-semibold text-base">
                Driver: <span class="text-primary">{{ selectedPickingList?.driverNo || '-' }}</span>
            </span>
            <span class="font-semibold text-base">
                Vehicle: <span class="text-primary">{{ selectedPickingList?.vehicleNo || '-' }}</span>
            </span>
        </div>
        <!-- Right side: Expand/Collapse buttons -->
        <div class="flex flex-wrap gap-2">
            <p-button label="Expand All" icon="pi pi-plus" text (onClick)="expandAll()" />
            <p-button label="Collapse All" icon="pi pi-minus" text (onClick)="collapseAll()" />
        </div>
    </div>
</ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 40px"></th>
                <th>Order No</th>
                <th>Customer Name</th>
                <th>Creation Date</th>
                <th *ngIf="!isReadOnly">Delete</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-order>
            <tr>
                <td>
                    <button type="button" pButton icon="pi pi-chevron-down" (click)="order.expanded = !order.expanded" [ngClass]="{ 'p-button-text': true }"></button>
                </td>
                <td>{{ order.orderNumber }}</td>
                <td>{{ order.customerName }}</td>
                <td>{{ order.creationDate }}</td>
                <td>
                    <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="confirmDeletePickingListLine(order)" title="Delete Order from Picking List" *ngIf="!isReadOnly"></button>
                </td>
            </tr>
            <tr *ngIf="order.expanded">
                <!-- Match colspan to the parent table columns (5 in your case) -->
                <td colspan="5" style="padding: 0">
                    <div style="padding: 1rem">
                        <b>Order Lines:</b>
                        <p-table [value]="order.orderLines" [tableStyle]="{ 'min-width': '35rem' }" class="p-mt-2" [scrollable]="true" [scrollHeight]="'200px'">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Item Name</th>
                                    <th>Quantity</th>
                                    <th>Pcs</th>
                                    <th>Size</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-line>
                                <tr>
                                    <td>{{ line.itemName }}</td>
                                    <td>{{ line.quantity }}</td>
                                    <td>{{ line.pcs }}</td>
                                    <td>{{ line.size }}</td>

                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" class="text-center py-4 text-gray-500">No orders found.</td>
            </tr>
        </ng-template>
    </p-table>
        <div *ngIf="!selectedPickingList || !selectedPickingList?.orders" class="p-4 text-center text-gray-500">
        No picking list selected or no orders found.
    </div>
    <ng-template pTemplate="footer">
        <!-- <p-button label="Close" icon="pi pi-times" (click)="pickingListDialogVisible = false"></p-button> -->
    </ng-template>
</p-dialog>

<p-dialog header="Add Orders to Picking List" [(visible)]="addOrdersDialogVisible" [modal]="true" [closable]="true">
    <p-table [value]="ordersToAdd" [(selection)]="selectedOrdersToAdd" selectionMode="multiple" dataKey="orderId" [rows]="10" [paginator]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 3em"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                <th>Order No</th>
                <th>Customer Name</th>
                <!-- Add other columns as needed -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-order>
            <tr [pSelectableRow]="order">
                <td><p-tableCheckbox [value]="order"></p-tableCheckbox></td>
                <td>{{ order.orderNumber }}</td>
                <td>{{ order.customerName }}</td>
            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" icon="pi pi-times" (click)="addOrdersDialogVisible = false"></button>
        <button pButton label="Add" icon="pi pi-check" [disabled]="!selectedOrdersToAdd.length" (click)="addOrdersToPickingList()"></button>
    </ng-template>
</p-dialog>
<!-- Add this anywhere in your template -->
<p-dialog header="Select Picking List" [(visible)]="addToExistingDialogVisible" [modal]="true" [closable]="true">
    <p-table [value]="recentPickingListsUpdate" selectionMode="single" [(selection)]="selectedPicklistForAdd" dataKey="pklId" [rows]="5" [paginator]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>Code</th>
                <th>Vehicle No</th>
                <th>Driver No</th>
                <th>From Date</th>
                <th>To Date</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-list let-index="rowIndex">
            <tr [pSelectableRow]="list">
                <td>{{ list.code }}</td>
                <td>{{ list.vehicleNo }}</td>
                <td>{{ list.driverNo }}</td>
                <td>{{ list.fromDate }}</td>
                <td>{{ list.toDate }}</td>
            </tr>
        </ng-template>

        <!-- Correct no-data template -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center py-4 text-gray-500">No data found for selected date range.</td>
            </tr>
        </ng-template>
    </p-table>

    <ng-template pTemplate="footer">
        <button pButton label="Cancel" icon="pi pi-times" (click)="addToExistingDialogVisible = false"></button>
        <button pButton label="Add Orders" icon="pi pi-check" [disabled]="!selectedPicklistForAdd" (click)="addSelectedOrdersToPicklist()"></button>
    </ng-template>
</p-dialog>
